<template>
    <div class="last" v-if="posts.length">
        <div class="last_posts">
            <router-link :to="post.link"
                class="last_post post" v-for="post in posts" :key="post.id">
                <img :src="post.images.large" alt="" srcset="" class="post_cover">
                <span v-text="publishedAt(post)" class="post_date"></span>
                <h2 v-text="post.title.rendered"></h2>
                <div class="post_excerpt" v-html="post.excerpt.rendered"></div>
                <BetButton :link="false" text="Ver Mais" mode="black" class="post_button"/>
            </router-link>
        </div>

    </div>
</template>

<script>
import BetButton from '@/components/BetButton.vue'
import moment from 'moment';

export default {
    name: 'LastMags',
    components: {
        BetButton,
    },
    props: {
        offset: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            postsSlideIndex: 0,
        }
    },
    methods: {
        publishedAt(post) {
            let publishedAt = moment(post.date).format("DD MMM YYYY")
            return publishedAt
        },
        goToNext() {
            let slides = parseInt(getComputedStyle(this.$el).getPropertyValue('--last-mags-nr'))
            this.postsSlideIndex = this.postsSlideIndex + slides
            if( this.postsSlideIndex >= this.posts.length ) {
                this.postsSlideIndex = 0
            }
        },
        goToPrev() {
            let slides = parseInt(getComputedStyle(this.$el).getPropertyValue('--last-mags-nr'))
            if( this.postsSlideIndex == 0 ) {
                let offset = slides - (this.posts.length % slides)
                if( offset == slides ) offset = 0
                this.postsSlideIndex = this.posts.length - slides + offset
            } else {
                this.postsSlideIndex = (this.postsSlideIndex - slides)
            }
        },
    },
    computed: {
        posts() {
            return this.$store.getters['betanomag/latest']({
                amount: 100,
                offset: this.offset,
            })
        },
        postsToDisplay() {
            let position = this.postsSlideIndex
            return this.posts.slice(position, position + 3)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
@import "@/assets/scss/queries";

.last {
  --last-mags-gap: 2rem;
  --last-mags-nr: 1;
  --last-mags-padding: 0 1rem;
  --last-mags-post-image-shadow: 0px 2px 8px 2px #610A0A;
  --last-mags-post-date-size: .5rem;
  --last-mags-post-padding: 1rem;
  --last-mags-post-text-size: .8rem;
  --last-mags-post-title-size: .8rem;

  @include media(md) {
    --last-mags-gap: 4rem;
    --last-mags-nr: 2;
    --last-mags-padding: 0 2rem;
    --last-mags-post-image-shadow: 0px 4px 20px 4px #610A0A;
    --last-mags-post-date-size: 1rem;
    --last-mags-post-padding: 2rem;
    --last-mags-post-text-size: 1rem;
    --last-mags-post-title-size: 1.5rem;
  }

  @include media(xl) {
    --last-mags-nr: 3;
  }

  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;

  gap: var(--last-mags-gap);
  padding: var(--last-mags-padding);

  &_navigation {
      grid-area: highlight;
      z-index: 10;
      position: absolute;
      pointer-events: none;
      top: calc(var(--side-padding) * 8);
      left: var(--side-padding);
      right: var(--side-padding);
      margin: auto 0;
      display: flex;
      justify-content: space-between;
      height: calc(var(--content-width) * .567);

      @include media(md) {
          bottom: 0;
          top: 0;
          left: 0;
          right: 0;
          height: calc(var(--content-width) * .167);
      }

      img {
          margin: auto 0;
          width: calc(var(--content-width) * .065 * .9 * 3);
          height: 100%;
          pointer-events: all;
          padding: 0 var(--side-padding);

          @include media(md) {
              height: calc(var(--content-width) * .065 * .4);
              width: calc(var(--content-width) * .065 * .4);
              padding: 0;
          }

          &.left {
              transform: rotate(180deg);
          }

      }
  }

  &_posts {
      display: flex;
      width: calc(100vw - 2 * var(--side-padding));
      overflow: hidden;
      gap: var(--last-mags-gap);
      flex-wrap: wrap;
  }

  &_post {
    --last-mags-width: calc((100% / var(--last-mags-nr)) - ((var(--last-mags-nr) - 1) * var(--last-mags-gap)) / var(--last-mags-nr));
    flex-grow: 1;
    flex-basis: 0;
    min-width: 0;
    background-color: $color-betano;
    display: flex;
    flex-direction: column;

    min-width: var(--last-mags-width);
    max-width: var(--last-mags-width);
    width: var(--last-mags-width);
  }
}

.post {
    text-decoration: none;
  padding: var(--last-mags-post-padding);
  gap: 1rem;

  h2 {
    text-transform: uppercase;
    color: $color-white;

    font-size: var(--last-mags-post-title-size);
  }

  &_cover {
    box-shadow: var(--last-mags-post-image-shadow);
  }

  &_date {
    text-transform: uppercase;
    margin: 0 auto;
    text-align: center;
    font-size: var(--last-mags-post-date-size);
  }

  &_excerpt {
    margin: 0 0 auto;
    color: $color-white;
    line-height: 1.5;

    font-size: var(--last-mags-post-text-size);
  }

  &_button {
    margin: auto auto 0;
  }
}
</style>
